let config = {
  secretKey: 'JOGvNcebnobFeokSv98tQilat3zhBRUI',
  secretId: 'AKIDJiyAJGVXK0TkomcEcmneHhz5ye7OSJyQ',
  appId: 1338090998,
}
window.config = config

